const MIN_LENGTH = 10;

export interface PasswordRules {
  lowercase: boolean;
  uppercase: boolean;
  number: boolean;
  symbol: boolean;
  minLength: boolean;
}

export function getPasswordRules(password: string): PasswordRules {
  return {
    lowercase: /[a-z]/.test(password),
    uppercase: /[A-Z]/.test(password),
    number: /\d/.test(password),
    symbol: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password),
    minLength: password.length >= MIN_LENGTH,
  };
}

export function isPasswordValid(rules: PasswordRules): boolean {
  return (
    rules.lowercase &&
    rules.uppercase &&
    rules.number &&
    rules.symbol &&
    rules.minLength
  );
}

export const PASSWORD_MIN_LENGTH = MIN_LENGTH;
